module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Book1/xhtml/fm01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter01"
    }
  }, [_vm._v("Chapter   1  "), _c('i', [_vm._v("Who Are We?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter02"
    }
  }, [_vm._v("Chapter   2  "), _c('i', [_vm._v("Bloody Waters")]), _vm._v("—"), _c('i', [_vm._v("Tarawa and Normandy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter03"
    }
  }, [_vm._v("Chapter   3  "), _c('i', [_vm._v("From Saipan to Tokyo Bay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter04"
    }
  }, [_vm._v("Chapter   4  "), _c('i', [_vm._v("A Different Breed")]), _vm._v("—"), _c('i', [_vm._v("Commandos from the Sea")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter05"
    }
  }, [_vm._v("Chapter   5  "), _c('i', [_vm._v("New Horizons")]), _vm._v("—"), _c('i', [_vm._v("and War in Korea")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter06"
    }
  }, [_vm._v("Chapter   6  "), _c('i', [_vm._v("Birth of the SEALs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter07"
    }
  }, [_vm._v("Chapter   7  "), _c('i', [_vm._v("A Pleasant Little War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter   8  "), _c('i', [_vm._v("The Men with Green Faces")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter   9  "), _c('i', [_vm._v("The Super SEALs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10  "), _c('i', [_vm._v("The Lieutenant (jg) Says No")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11  "), _c('i', [_vm._v("The March of the Jedi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12  "), _c('i', [_vm._v("A Tiny Little Island")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13  "), _c('i', [_vm._v("Target: Manuel Noriega")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14  "), _c('i', [_vm._v("To the Persian Gulf")]), _vm._v("—"), _c('i', [_vm._v("and Beyond")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d795d59a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/contents.vue
// module id = 81
// module chunks = 0